module.exports = __webpack_public_path__ + "img/706.d6ecf609.jpg";